export {
  default as adaCompliant,
  ReactComponent as AdaCompliant,
} from '@assets/icons/features-and-amenities/ada-compliant.svg'    
